import LeftPanelWrapper from './LeftPanelWrapper';

export default LeftPanelWrapper;
